import baseAPI from "@/api/base";
import { AxiosResponse } from "axios";

const AI_ASSISTANT_URL = "/ai-assistant";

class AIAssistantService {
  /**
   * Pre-call context prep — fires n8n Workflow 1 before the call starts.
   * Call this when the user clicks "Call with AI" to begin preparing the briefing.
   */
  static prepareContext = async (contactId: string, icpId?: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(`${AI_ASSISTANT_URL}/prepare-context`, {
      contactId,
      icpId,
    });
    return response;
  };

  static enable = async (params: {
    callSid: string;
    parentCallSid?: string;
    contactId: string;
    icpId?: string;
  }): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(`${AI_ASSISTANT_URL}/enable`, params);
    return response;
  };

  static disable = async (callSid: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(`${AI_ASSISTANT_URL}/disable`, {
      callSid,
    });
    return response;
  };
}

export default AIAssistantService;
